<div class="main-content table-page table-page--compact denuncias-correos-page">
  <div class="container-fluid">
    <section class="table-page__hero">
      <div class="table-page__copy">
        <h1>Correos de Denuncias</h1>
        <p>Copias administrativas que reciben el acuse de registro de una denuncia.</p>
      </div>
      <div class="table-page__toolbar-actions">
        <div class="denuncias-correos-page__fixed-mail" title="El destinatario fijo no se administra aquí.">
          <span>Destinatario fijo</span>
          <strong>denuncias@solsersistem.net</strong>
        </div>
        <button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="volver()" title="Regresar">
          <i class="material-icons">arrow_back</i>
          Regresar
        </button>
      </div>
    </section>

    <div class="row denuncias-correos-page__layout">
      <div class="col-12 col-xl-4">
        <section class="table-page__card denuncias-correos-page__form-card">
          <div class="denuncias-correos-page__card-header">
            <h2>{{ editando ? 'Editar copia administrativa' : 'Agregar copia administrativa' }}</h2>
          </div>

          <div class="app-form-grid">
            <label class="app-form-field app-form-field--full">
              <span class="app-form-field__label">Alias</span>
              <input
                type="text"
                class="app-form-field__control"
                [(ngModel)]="formulario.conf_fol_se_dsc"
                maxlength="80"
                placeholder="Ej. Cumplimiento" />
            </label>

            <label class="app-form-field app-form-field--full">
              <span class="app-form-field__label">Correo electrónico</span>
              <input
                type="email"
                class="app-form-field__control"
                [(ngModel)]="formulario.valor1"
                maxlength="120"
                placeholder="correo@solsersistem.net" />
            </label>
          </div>

          <div class="app-form-actions">
            <button
              type="button"
              class="app-form-btn app-form-btn--secondary app-form-btn--compact"
              (click)="cancelarEdicion()"
              [disabled]="guardando && !editando">
              Limpiar
            </button>

            <button
              type="button"
              class="app-form-btn app-form-btn--primary app-form-btn--compact"
              (click)="guardar()"
              [disabled]="guardando">
              {{ guardando ? 'Guardando...' : (editando ? 'Actualizar' : 'Agregar') }}
            </button>
          </div>
        </section>
      </div>

      <div class="col-12 col-xl-8">
        <section class="table-page__card">
          <div class="table-page__toolbar">
            <div class="table-page__toolbar-copy">
              <h2>Copias configuradas</h2>
              <p>{{ correos.length }} registro{{ correos.length === 1 ? '' : 's' }} activo{{ correos.length === 1 ? '' : 's' }}</p>
            </div>
          </div>

          <div class="table-page__table-wrap" *ngIf="correos.length > 0; else correosEmptyState">
            <table class="table-page__table">
              <thead>
                <tr>
                  <th>Alias</th>
                  <th>Correo</th>
                  <th class="table-page__actions-head">Acciones</th>
                </tr>
              </thead>

              <tbody>
                <tr *ngFor="let item of correosPagina()">
                  <td>
                    <div class="table-page__cell-stack">
                      <strong class="table-page__name">{{ item.conf_fol_se_dsc || 'Sin alias' }}</strong>
                      <span class="table-page__subtext">Secuencia {{ item.conf_fol_se }}</span>
                    </div>
                  </td>
                  <td>
                    <span class="table-page__text">{{ item.valor1 }}</span>
                  </td>
                  <td class="table-page__actions">
                    <button type="button" class="table-page__action-btn" (click)="editar(item)">
                      <i class="material-icons">edit</i>
                    </button>
                    <button
                      type="button"
                      class="table-page__action-btn table-page__action-btn--danger"
                      (click)="eliminar(item)"
                      [disabled]="eliminandoId === item.conf_fol_se">
                      <i class="material-icons">{{ eliminandoId === item.conf_fol_se ? 'hourglass_top' : 'delete' }}</i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="table-page__footer" *ngIf="correos.length > 0 && totalPaginas() > 1">
            <div class="table-page__meta">
              Mostrando {{ rangoInicio() }}–{{ rangoFin() }} de {{ correos.length }}
            </div>
            <nav class="table-page__pager">
              <button type="button" class="table-page__pager-link" (click)="primeraPagina()"
                [disabled]="paginaNorm() <= 1" title="Primera página"><span class="material-icons">first_page</span></button>
              <button type="button" class="table-page__pager-link" (click)="paginaAnterior()"
                [disabled]="paginaNorm() <= 1" title="Página anterior"><span class="material-icons">chevron_left</span></button>
              <ng-container *ngFor="let p of getPaginationItems()">
                <button *ngIf="isPageNumber(p)" type="button" class="table-page__pager-page"
                  [class.is-current]="p === paginaNorm()" (click)="irPagina(p)">{{ p }}</button>
                <span *ngIf="!isPageNumber(p)" class="table-page__pager-ellipsis">…</span>
              </ng-container>
              <button type="button" class="table-page__pager-link" (click)="paginaSiguiente()"
                [disabled]="paginaNorm() >= totalPaginas()" title="Página siguiente"><span class="material-icons">chevron_right</span></button>
              <button type="button" class="table-page__pager-link" (click)="ultimaPagina()"
                [disabled]="paginaNorm() >= totalPaginas()" title="Última página"><span class="material-icons">last_page</span></button>
            </nav>
          </div>

          <ng-template #correosEmptyState>
            <div class="table-page__empty" *ngIf="!cargando; else correosLoadingState">
              <i class="material-icons">mail_lock</i>
              <strong>No hay copias configuradas</strong>
              <span>Agregue correos administrativos adicionales desde el formulario.</span>
            </div>
          </ng-template>

          <ng-template #correosLoadingState>
            <div class="table-page__empty table-page__empty--loading">
              <i class="material-icons">hourglass_top</i>
              <strong>Cargando configuración...</strong>
            </div>
          </ng-template>
        </section>
      </div>
    </div>
  </div>
</div>
